import React from "react";
import {
  Button,
  Section,
  Heading,
  Columns,
  Column,
  Hidden,
  Box,
} from "@origin-digital/ods-core";
import styled from "styled-components";
import content from "./content.json";
import { getImageFromCloudinary } from "src/utils/helpers";

export interface IRegisterSectionProps {
  link: string;
}

const Image = styled.img`
  width: 100%;
  max-width: 281px;
  height: auto;
`;

export const RegisterSection: React.FC<IRegisterSectionProps> = ({ link }) => (
  <Section paddingY="none">
    <Hidden above="sm">
      <Box marginY="medium">
        <Columns space="xlarge" alignX="center" alignY="center">
          <Column width="flex">
            <Hidden below="sm">
              <Heading variant="h3" align="left">
                {content.heading}
              </Heading>
            </Hidden>
            <Hidden above="xs">
              <Heading variant="h4" align="left">
                {content.heading}
              </Heading>
            </Hidden>
          </Column>
          <Column width="content">
            <Button href={link} variant="contained" size="small">
              {content.cta.text}
            </Button>
          </Column>
        </Columns>
      </Box>
    </Hidden>
    <Hidden below="md">
      <Columns space="xlarge" alignX="center" alignY="center">
        <Column width="content">
          <Image src={getImageFromCloudinary(112, 281, content.icon, "fill")} />
        </Column>
        <Column width="flex">
          <Heading variant="h2" align="center">
            {content.heading}
          </Heading>
        </Column>
        <Column width="content">
          <Button href={link} variant="contained">
            {content.cta.text}
          </Button>
        </Column>
      </Columns>
    </Hidden>
  </Section>
);
